﻿import $ from "jquery";

$('.clothing-hygiene-diagram-block').clothingHygieneStatistics();